import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { getApi, postApi } from '../../Services/apiService';
import moment from 'moment';

const AddEventModal = ({ setAddEventModal, fetchEvents }) => {
    const [loader, setLoader] = useState(false);
    const [price, setPrice] = useState('');
    const [categories, setCategories] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [categorySearch, setCategorySearch] = useState("");
    const [isCategoryListOpen, setIsCategoryListOpen] = useState(false);
    const [selectedCategoryId, setSelectedCategoryId] = useState(false);
    const [error, setError] = useState({});
    const [formData, setFormData] = useState({
        name: '',    
        special_offer: '',
        description: '',
        entry_booking_detail: '',
        booking_url: '',
        type: '',
        category_id: '',
        start_time: '',
        end_time: '',
        date:'',
        price:"",
        images: []
    });
    const [filePreviews, setFilePreviews] = useState({
        banner_image: null,
        images: []
    });
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
    };

    const handleCategorySearchChange = (e) => {
        const searchTerm = e.target.value;
        setCategorySearch(searchTerm);
        const filtered = categories.filter((cat) =>
            cat.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredCategories(filtered);
        setIsCategoryListOpen(true);
    };

    // const handleCategorySelect = (category) => {
    //     setFormData({ ...formData, category_id: category.id });
    //     setCategorySearch(category.name);
    //     setIsCategoryListOpen(false);
    //     if (errors.category_id) {
    //         setErrors({ ...errors, category_id: '' });
    //     }
    // };

    const handleCategorySelect = (category) => {
        setCategorySearch(category.name);
        setSelectedCategoryId(category.id);
        setFormData({ ...formData, category_id: category.id }); // Add this line
        setIsCategoryListOpen(false);
        if (errors.category_id) {
            setErrors({ ...errors, category_id: '' });
        }
    };
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (name === 'images') {
            const filesArray = Array.from(files);
            setFormData({ ...formData, images: filesArray });
            const previewsArray = filesArray.map(file => URL.createObjectURL(file));
            setFilePreviews({ ...filePreviews, images: previewsArray });
            if (errors.images) {
                setErrors({ ...errors, images: '' });
            }
        }
    };

    const handleRemoveFile = (name, index) => {
       if (name === 'images') {
            const updatedImages = [...formData.images];
            updatedImages.splice(index, 1);
            setFormData({ ...formData, images: updatedImages });

            const updatedPreviews = [...filePreviews.images];
            updatedPreviews.splice(index, 1);
            setFilePreviews({ ...filePreviews, images: updatedPreviews });
            if (updatedImages.length === 0) {
                setErrors({ ...errors, images: 'At least one image is required.' });
            }
        }
    };

    const validateForm = () => {
        let validationErrors = {};
    
        // Name validation
        if (!formData.name.trim()) {
            validationErrors.name = "Name is required.";
        } else if (formData.name.trim().length < 2 || formData.name.trim().length > 35) {
            validationErrors.name = "Name must be between 2 and 35 characters.";
        }
    
        // Description validation
        if (!formData.description.trim()) {
            validationErrors.description = "Description is required.";
        } else if (formData.description.trim().length < 2 || formData.description.trim().length > 500) {
            validationErrors.description = "Description must be between 2 and 500 characters.";
        }
    
        // Start time validation
        if (!formData.start_time.trim()) {
            validationErrors.start_time = "Start time is required.";
        }
    
        // End time validation
        if (!formData.end_time.trim()) {
            validationErrors.end_time = "End time is required.";
        }
        if (formData.start_time.trim() && formData.end_time.trim()) {
            const startTime = moment(formData.start_time, "HH:mm");
            const endTime = moment(formData.end_time, "HH:mm");
            // if (!endTime.isAfter(startTime)) {
            //     validationErrors.end_time = "End time must be greater than start time.";
            // }
        }
        if (!formData.entry_booking_detail) {
            validationErrors.entry_booking_detail = "Entry Booking is required.";
        }
    
        // Type validation
        if (!formData.type.trim()) {
            validationErrors.type = "Type is required.";
        }

        if (!formData.date.trim()) {
            validationErrors.date = "Date is required.";
        }
    
        // Price validation
        if (!formData.price.trim()) {
            validationErrors.price = "Price is required.";
        }

        // Category ID validation
        if (!formData.category_id) {
            validationErrors.category_id = "Venue is required.";
        }
    
        // Image validation
        if (formData.images.length === 0) {
            validationErrors.images = "At least one image is required.";
        }
    
        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };
    
    const convertTimeToMilliseconds = (time) => {
        if (!time) return null;
    
        const [hours, minutes] = time.split(":").map(Number);
        const now = new Date();
        now.setHours(hours, minutes, 0, 0);
    
        return now.getTime();
    };
    
    const handleSubmit = async () => {
        if (!validateForm()) return;
    
        setLoader(true);
        const formDataToSend = new FormData();
        const expiryDateTimestamp = new Date(formData.date).getTime();
        
        const formattedData = {
            ...formData,
            start_time: convertTimeToMilliseconds(formData.start_time),
            end_time: convertTimeToMilliseconds(formData.end_time),
            date: expiryDateTimestamp,
        };
    
        Object.keys(formattedData).forEach((key) => {
            if (key === 'images' && Array.isArray(formattedData.images)) {
                formattedData.images.forEach((file) => formDataToSend.append('images', file));
            } else {
                formDataToSend.append(key, formattedData[key]);
            }
        });
    
        try {
            const response = await postApi('/admin/add-event', formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
    
            if (response.status === 200) {
                setAddEventModal(false);
                fetchEvents();
            }
        } catch (error) {
            console.error("Error adding event:", error);
        } finally {
            setLoader(false);
        }
    };
    
    useEffect(() => {
        fetchCategories();
    }, []);
    
    const fetchCategories = async () => {
        try {
            const response = await getApi("/admin/category");
            if (response.status === 200) {
                setCategories(response?.data?.data);
                console.log("  setCategories(response?.data?.data);" ,   response?.data?.data);
                
                setFilteredCategories(response?.data?.data);
            }
        } catch (error) {
            console.error("Failed to fetch categories:", error);
        }
    };

    return (
        <div className='detail-page-modal'>
            <div className='modal-header'>
                <h3>Add Event</h3>
                <button className='close-button' onClick={() => setAddEventModal(false)}>
                    <img src={window.getPublicUrl('/assets/images/Close_round_light.svg')} alt='close' />
                </button>
            </div>
            <div className='modal-body scrollable-modal-body add-offer-scroll'>
                <div className='input-main'>
                    <div className='row'>
                        {Object.keys(formData).map((key) =>
                            !["images", "type", "category_id", "special_offer", "entry_booking_detail", "description"].includes(key) ? (
                                <div className="col-sm-6" key={key}>
                                    <div className="custom-floating-group">
                                        <input
                                            type={
                                                key === "start_time" || key === "end_time"
                                                    ? "time"
                                                    : key === "date"
                                                    ? "date"
                                                    : "text"
                                            }
                                            name={key}
                                            placeholder=" "
                                            value={formData[key] || ""}
                                            onChange={handleChange}
                                            onClick={(e) => {
                                                if (key === "date" && e.target.showPicker) {
                                                    e.target.showPicker();
                                                }
                                            }}
                                            onBlur={(e) => {
                                                if (key === "date") {
                                                    setFormData({
                                                        ...formData,
                                                        [key]: moment(e.target.value).format("YYYY-MM-DD"),
                                                    });
                                                }
                                            }}
                                            min={key === "date" ? moment().format("YYYY-MM-DD") : undefined}
                                        />
                                        <label>{key.replace(/_/g, " ")}</label>
                                        {errors[key] && (
                                            <span style={{ color: "red", fontSize: "14px" }}>
                                                {errors[key]}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            ) : null
                        )}

                        <div className='col-sm-6'>
                            <div className='custom-floating-group'>
                                <select name='type' value={formData.type} onChange={handleChange}>
                                    <option value=''>Select Venue Type</option>
                                    <option value='0'>Music</option>
                                    <option value='1'>Food And Drinks</option>
                                    <option value='2'>Themed Nights</option>
                                    <option value='3'>Nightclubs & Guest Lists</option>
                                </select>
                                <label>Type</label>
                                {errors.type && (
                                    <span style={{ color: "red", fontSize: "14px" }}>
                                        {errors.type}
                                    </span>
                                )}
                            </div>
                        </div>
                      
                        <div className="col-sm-6">
                            <div className="custom-floating-group">
                                <input 
                                    type="text"
                                    className="form-control category" 
                                    name="category_search"
                                    placeholder="Search Venue"
                                    value={categorySearch}
                                    onChange={handleCategorySearchChange}
                                    onFocus={() => setIsCategoryListOpen(true)}
                                />
                   
                                
                                {isCategoryListOpen && (
                                    <ul 
                                        className="search-listing-ul" 
                                        style={{ 
                                            width: "100%", 
                                            position: "absolute",
                                            zIndex: 1,
                                            marginTop: "5px"
                                        }}
                                    >
                                        {filteredCategories.map((category) => (
                                         <li
                                         key={category.id}
                                         onClick={() => handleCategorySelect(category)}
                                         className={selectedCategoryId === category.id ? "active" : ""}
                                     >
                                         {category.name}
                                     </li>
                                        ))}
                                        {filteredCategories.length === 0 && categorySearch && (
                                            <li>No venues found</li>
                                        )}
                                    </ul>
                                )}
                                
                                {errors.category_id && <span style={{ color: "red", fontSize: "14px" }}>{errors.category_id}</span>}
                            </div>
                        </div>

                        <div className="col-sm-6">
                            <div className="custom-floating-group position-relative">
                                <textarea
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    placeholder=" "
                                    rows="4"
                                    className={`custom-textarea ${formData.description ? "has-content" : ""}`}
                                ></textarea>
                                <label className="floating-label">Description</label>
                                {errors.description && (
                                    <span style={{ color: "red", fontSize: "14px" }}>
                                        {errors.description}
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="col-sm-6">
                            <div className="custom-floating-group position-relative">
                                <textarea
                                    name="special_offer"
                                    value={formData.special_offer}
                                    onChange={handleChange}
                                    placeholder=" "
                                    rows="4"
                                    className={`custom-textarea ${formData.special_offer ? "has-content" : ""}`}
                                ></textarea>
                                <label className="floating-label">Enter special offer details</label>
                                {errors.special_offer && (
                                    <span style={{ color: "red", fontSize: "14px" }}>
                                        {errors.special_offer}
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="col-sm-6">
                            <div className="custom-floating-group position-relative height">
                                <textarea
                                    name="entry_booking_detail"
                                    value={formData.entry_booking_detail}
                                    onChange={handleChange}
                                    placeholder=" "
                                    rows="4"
                                    className={`custom-textarea ${formData.entry_booking_detail ? "has-content" : ""}`}
                                ></textarea>
                                <label className="floating-label">Enter booking details</label>
                                {errors.entry_booking_detail && (
                                    <span style={{ color: "red", fontSize: "14px" }}>
                                        {errors.entry_booking_detail}
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="col-sm-6">
                            <div className="upload-wrapper">
                                <input
                                    type="file"
                                    id="images"
                                    name="images"
                                    className="upload-input"
                                    onChange={handleFileChange}
                                    multiple
                                />
                                <label htmlFor="images" className="upload-label">
                                    <img className='upload-icon' src={window.getPublicUrl("/assets/images/upload.svg")} alt="" />
                                    Images
                                    <div className="upload-box">
                                        {errors.images && (
                                            <span style={{ color: "red", fontSize: "14px" }}>
                                                {errors.images}
                                            </span>
                                        )}
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div className="col-sm-12 text-center">
                            {filePreviews.images.map((preview, index) => (
                                <div className="file-preview" key={index}>
                                    <img src={preview} alt={`Preview ${index}`} />
                                    <button className='cross' onClick={() => handleRemoveFile('images', index)}>
                                        <img src="https://admin.abroadbible.net/assets/images/gray-cross.svg" alt="" />
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className='modal-footer'>
                <button className='cancel' onClick={() => setAddEventModal(false)}>Cancel</button>
                <button className='save' onClick={handleSubmit} disabled={loader}>
                    {loader && <div className='spinner-border' role='status'></div>}
                    Save
                </button>
            </div>
        </div>
    );
};

export default AddEventModal;